@use "variables" as *;
@use "../../helpers/bookingListStyles/BookingListStyles.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  gap: $spacing-2;
}

.tooltipWrapper {
  @include on-bp(md) {
    width: calc(BookingListStyles.$passengers-width - 105px);
  }
}
